import React from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import "./BottomImageCarousel.css";

// EXAMPLE IMPORTS (replace these paths with your own)
import img1 from "../images/B2022D19-06B5-46E5-BB89-176A186FA3872023-11-10_14-14-38_636.png";
import img2 from "../images/Pic again.png";
import img3 from "../images/Runbier helping again.jpeg";
import img4 from "../images/Runbier helping.jpeg";

export default function BottomImageCarousel() {
  return (
    <div className="bottom-carousel-section">
      <h2 className="bottom-carousel-title">Gallery</h2>

      <Carousel
        showThumbs={false}
        autoPlay={true}
        infiniteLoop={true}
        showStatus={false}
        interval={3500}
        swipeable={true}
        emulateTouch={true}
        stopOnHover={true}
      >
        <div>
          <img src={img1} alt="Gallery item 1" />
        </div>

        <div>
          <img src={img2} alt="Gallery item 2" />
        </div>

        <div>
          <img src={img3} alt="Gallery item 3" />
        </div>

        <div>
          <img src={img4} alt="Gallery item 3" />
        </div>

        {/* Add or remove slides as needed */}
      </Carousel>
    </div>
  );
}
